import { inject, Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { IToken } from "../interfaces/token.interface";

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private readonly authenticationService = inject(AuthenticationService);

  hasAccess(allowedRoles: string[]): boolean {
    const token: IToken = this.authenticationService.extractToken();
    const userRole = token.role;

    if (userRole) {
      return allowedRoles.indexOf(userRole || '') > -1;
    }

    return false;
  }

  isRole(role: string): boolean {
    const token: IToken = this.authenticationService.extractToken();
    const userRole = token.role;

    if (userRole) {
      return userRole === role;
    }

    return false;
  }
}